import type {NodeParameters} from "@cm/graph-v3"
import type {MaterialGraph} from "@cm/material-nodes"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import {TemplateNode} from "#template/template-node/template-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import type {MaterialLikeNode} from "#template/nodes/material/fundamental"
import {materialLikeMarker} from "#template/nodes/material/fundamental"
import {fundamentalLikeMarker} from "#template/role-markers"
import type {NodeEvaluator} from "#template/node-evaluator"

export abstract class MaterialNode<out Parameters extends NodeParameters = NodeParameters, out ConstructorParameters extends NodeParameters = Parameters>
    extends TemplateNode<Parameters, ConstructorParameters>
    implements MaterialLikeNode
{
    get [materialLikeMarker]() {
        return true as const
    }
    get [fundamentalLikeMarker]() {
        return true as const
    }

    public abstract override get definition(): TemplateNodeDefinition<Parameters, ConstructorParameters>

    public abstract evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<MaterialGraph | null>
}
